import { Button, Checkbox, Container, TextField } from "@mui/material";
import { Box } from "@mui/system";
import Typography from "@mui/material/Typography";
import { StyledEngineProvider, styled } from "@mui/material/styles";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Link, NavLink } from "react-router-dom";
import logo from "../../assets/img/logos/logo-grupo-monaco.jpg";
import "./LoginForm.css";

const LoginTextField = styled(TextField)({
	input: {
		color: "#292929",
		"&:-webkit-autofill": {
			WebkitBoxShadow: "0 0 0 1000px #fdfeff inset",
			WebkitTextFillColor: "#292929 !important",
		},
	},
	InputLabelProps: {
		color: "#292929",
		fontFamily: "Quicksand",
	},
	"&:-webkit-autofill": {
		WebkitBoxShadow: "0 0 0 1000px white inset",
	},
	"& label.Mui-focused": {
		color: "#292929",
	},
	"& .MuiOutlinedInput-root": {
		"& fieldset": {
			borderColor: "#292929",
		},
		"&:hover fieldset": {
			borderColor: "#292929",
		},
		"&.Mui-focused fieldset": {
			borderColor: "#e60b13",
		},
	},
});

const LoginForm = ({
	user,
	handleSubmit,
	handleChange,
	isChecked,
	handleChecked,
}) => {
	return (
		<StyledEngineProvider injectFirst>
			<Link to="/">
				<Box
					float="left"
					display="flex"
					margin="1rem 0 0 1rem"
					alignItems="center"
				>
					<ArrowBackIosNewIcon sx={{ fontSize: 16 }} />
					<Typography variant="subtitle2" color="initial" ml={1}>
						Volver a home
					</Typography>
				</Box>
			</Link>
			<Container
				maxWidth="xs"
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "space-between",
					alignItems: "center",
					height: "calc(100vh - 38px)",
					color: "#292929",
					paddingTop: 3,
					paddingBottom: 3,
				}}
			>
				<Box component="div" sx={{ height: "fit-content" }}>
					<Link to="/">
						<img src={logo} alt="Logo Grupo Monaco" className="login-logo" />
					</Link>
					<Box
						component="form"
						onSubmit={handleSubmit}
						sx={{ textAlign: "center" }}
						autoComplete="on"
					>
						<Typography
							component="h1"
							variant="h5"
							sx={{ fontSize: "1rem", fontFamily: "Quicksand" }}
						>
							INICIAR SESIÓN
						</Typography>
						<LoginTextField
							id="userAccount"
							value={user.userAccount}
							fullWidth
							label="Usuario"
							placeholder="CUIT o DNI de registro"
							name="userAccount"
							type="text"
							variant="outlined"
							margin="normal"
							onChange={handleChange}
							autoComplete="on"
						/>
						<LoginTextField
							id="password"
							autoComplete="new-password"
							fullWidth
							label="Contraseña"
							name="userPassword"
							type="password"
							variant="outlined"
							margin="normal"
							onChange={handleChange}
							InputLabelProps={{
								style: { color: "#292929", fontFamily: "Quicksand" },
							}}
							sx={{ input: { color: "#292929" } }}
						/>
						<Typography
							component="h1"
							variant="h5"
							sx={{
								fontSize: "0.90rem",
								fontFamily: "Quicksand, sans-serif",
								textAlign: "center",
							}}
							className="checkBoxText"
						>
							<Checkbox
								color="brand"
								style={{ width: 33 }}
								checked={isChecked}
								onChange={handleChecked}
							/>
							Recordarme
						</Typography>
						<Button
							type="submit"
							color="brand"
							fullWidth
							variant="contained"
							sx={{
								mt: 2,
								fontSize: "1rem",
								fontWeight: 700,
								textTransform: "none",
								marginBottom: "0.7rem",
							}}
							style={{ fontFamily: "Quicksand" }}
						>
							Ingresar
						</Button>
						<Button
							color="secondary"
							style={{
								fontFamily: "Quicksand",
								textTransform: "none",
							}}
						>
							<NavLink
								to="/new-password-request"
								className="new-password-request"
								style={{ color: "#292929" }}
							>
								¿Olvidaste tu contraseña?
							</NavLink>
						</Button>
					</Box>
					<Box display="flex" alignItems="baseline" justifyContent="center">
						<Typography sx={{ fontFamily: "Quicksand" }}>
							¿No sos cliente?{" "}
						</Typography>
						<Button
							color="secondary"
							style={{
								fontSize: "1rem",
								fontFamily: "Quicksand",
								textTransform: "none",
								color: "#292929",
							}}
						>
							<NavLink to="/create-user" className="create-user-link">
								Crea tu cuenta
							</NavLink>{" "}
						</Button>
					</Box>
				</Box>
			</Container>
		</StyledEngineProvider>
	);
};

export default LoginForm;
